export default "__VITE_ASSET__106c3de6__"